import { requestEditorTour } from '../../actions/AppActions';
const STEP_KEYS = {
  createFromTemplate: 'createFromTemplate'
};
export const STEP_TO_OPTIONS = {
  createFromTemplate: {
    attachTo: '[data-test-id="side-nav-item-defaultTemplates"],[data-test-id="create-side-nav"]',
    placement: 'right',
    pulser: false
  }
};
export const TOUR_1 = {
  key: 'dashboard-initial-tour',
  config: {
    steps: [STEP_KEYS.createFromTemplate]
  }
};
export const TOUR_TO_FINISH_OPTIONS = {
  'dashboard-initial-tour': {
    beforeFinishReduxAction: requestEditorTour()
  }
};
export const ALL_TOURS = [TOUR_1];
export const TOURS_BY_KEY = new Map(ALL_TOURS.map(tour => [tour.key, {
  config: tour.config
}]));